import type {
  BalanceRegistration,
  BalanceSlot,
} from '@sportninja/common/services/teamBalance'

export interface SlotTarget {
  slot: BalanceSlot
  registration: BalanceRegistration
}

/**
 * The slot a sheet action targets (a modal or the payments drawer), with its whole
 * parent registration, resolved from the SERVER payload rather than the flattened
 * table row, so whatever it opened re-reads the slot after every refetch.
 *
 * Null when nothing is targeted, or when the slot is no longer on the sheet.
 */
export const resolveSlotTarget = (
  registrations: readonly BalanceRegistration[],
  slotId: string | null
): SlotTarget | null => {
  if (slotId === null) {
    return null
  }
  for (const registration of registrations) {
    const slot = registration.slots.find((candidate) => candidate.id === slotId)
    if (slot) {
      return { slot, registration }
    }
  }
  return null
}
